var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parsePlaceholders } from '@widget/forms/inputs/PillInput/pill-input-utils';
import { executeConfig, useExecuteRequest } from '@core/context/useExecuteRequest';
import { NotificationServices } from './notificationServices';
export const MessageBusChannel = 'iviva_notification_bridge_updates';
export const PollingInterval = 300000; // 5 min
export function resolvePlaceholders(template, params = {}) {
    return String(parsePlaceholders(template, params));
}
export function markReadUnread(context, notificationId, read) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield executeConfig(context, NotificationServices.markReadUnread(notificationId, read));
        return data === true;
    });
}
export function useNotificationCenter(counter) {
    var _a;
    const { data, loading: loadingCriteria } = useExecuteRequest(NotificationServices.getCriteria, { dependencies: [counter], defaultValue: { categories: [], totalUnread: 0 } });
    return {
        isLoading: loadingCriteria,
        categories: Array.isArray(data === null || data === void 0 ? void 0 : data.categories) ? data.categories : [],
        totalUnread: (_a = data === null || data === void 0 ? void 0 : data.totalUnread) !== null && _a !== void 0 ? _a : 0,
    };
}
